import { render, staticRenderFns } from "./GroupMindCrumbs.vue?vue&type=template&id=2ff415b6"
import script from "./GroupMindCrumbs.vue?vue&type=script&lang=js"
export * from "./GroupMindCrumbs.vue?vue&type=script&lang=js"
import style0 from "./GroupMindCrumbs.vue?vue&type=style&index=0&id=2ff415b6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports